import { MapPinIcon } from '@heroicons/react/20/solid'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const buttonClassName = 'inline-flex items-center justify-center gap-2 rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-xs transition hover:bg-indigo-500 disabled:cursor-not-allowed disabled:opacity-60'

const toCoordinate = value => {
	if (value === '' || value == null) return null
	const parsed = Number(value)
	return Number.isFinite(parsed) ? parsed : null
}

const buildGoogleMapsNavigationUrl = (lat, lng) => `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`

export default function NavigateButton({ training, className = buttonClassName }) {
	const { t } = useTranslation()
	const coordinates = useMemo(() => {
		const lat = toCoordinate(training?.g_lat)
		const lng = toCoordinate(training?.g_long)

		if (lat == null || lng == null) return null
		return { lat, lng }
	}, [training?.g_lat, training?.g_long])

	const label = (
		<>
			<MapPinIcon className="size-4" aria-hidden="true" />
			{t('trainings.details.actions.navigate')}
		</>
	)

	if (!coordinates) {
		return (
			<button type="button" disabled className={className}>
				{label}
			</button>
		)
	}

	return (
		<a
			href={buildGoogleMapsNavigationUrl(coordinates.lat, coordinates.lng)}
			target="_blank"
			rel="noreferrer"
			className={className}
		>
			{label}
		</a>
	)
}
